import Overlay from "@/components/overlay";
import {useSelector} from "react-redux";
import {GET_LOADING} from "@/store/slices/appSlice";
import styled from "styled-components";

const ImgLoading = styled.img `
animation: is-rotating 1s infinite;
@keyframes is-rotating {
    to {
      transform: rotate(1turn);
    }
  }
`
export default function Loading() {
    const loading: boolean = useSelector(GET_LOADING)

    return (
        <>
            <Overlay className={loading ? 'show' : ''}>
                {loading &&
                    <ImgLoading src={'/imgs/loading.png'} alt="loading" width={70} height={70}></ImgLoading>
                }
            </Overlay>
        </>
    )

}